var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('div',{staticClass:"tituloOnco tituloEscritorio"},[_c('img',{attrs:{"src":_vm.barraFondo,"alt":"Imagen Escritorio"}})]),_c('div',{staticClass:"tituloOnco tituloMobile"},[_c('img',{attrs:{"src":_vm.barraFondoMobile,"alt":"Imagen Móvil"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }